'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Spinner = undefined;

var _templateObject = _taggedTemplateLiteral(['\n\t0% {\n\t\ttransform: rotate(0deg);\n\t}\n\n\t100% {\n\t\ttransform: rotate(360deg);\n\t}\n'], ['\n\t0% {\n\t\ttransform: rotate(0deg);\n\t}\n\n\t100% {\n\t\ttransform: rotate(360deg);\n\t}\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 100%;\n\n\t> span {\n\t\tborder: ', ' solid ', ';\n\t\tborder-left: ', ' solid ', ';\n\t\ttransform: translateZ(0);\n\t\tanimation: ', ' 1.1s infinite cubic-bezier(0.785, 0.135, 0.15, 0.86);\n\t\tborder-radius: 50%;\n\t\twidth: ', ';\n\t\theight: ', ';\n\t}\n'], ['\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 100%;\n\n\t> span {\n\t\tborder: ', ' solid ', ';\n\t\tborder-left: ', ' solid ', ';\n\t\ttransform: translateZ(0);\n\t\tanimation: ', ' 1.1s infinite cubic-bezier(0.785, 0.135, 0.15, 0.86);\n\t\tborder-radius: 50%;\n\t\twidth: ', ';\n\t\theight: ', ';\n\t}\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _utils = require('../utils.js');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getColor = _utils2.default.getColor;


var spin = (0, _styledComponents.keyframes)(_templateObject);

var getSize = function getSize(_ref) {
	var xs = _ref.xs,
	    sm = _ref.sm,
	    md = _ref.md,
	    lg = _ref.lg,
	    xl = _ref.xl;

	switch (true) {
		case xs:
			return '15px';
		case sm:
			return '25px';
		case md:
			return '30px';
		case lg:
			return '50px';
		case xl:
			return '75px';
		default:
			return '30px';
	}
};

var getThickness = function getThickness(_ref2) {
	var xs = _ref2.xs,
	    sm = _ref2.sm,
	    md = _ref2.md,
	    lg = _ref2.lg,
	    xl = _ref2.xl;

	switch (true) {
		case xs:
			return '3px';
		case sm:
			return '4px';
		case md:
			return '4px';
		case lg:
			return '5px';
		case xl:
			return '6px';
		default:
			return '4px';
	}
};

var StyledSpinner = _styledComponents2.default.span(_templateObject2, function (props) {
	return getThickness(props);
}, function (props) {
	return getColor(props, 'rgba(0, 0, 0, 0.1)');
}, function (props) {
	return getThickness(props);
}, function (props) {
	return props.tint ? '#ecf5fd' : '#fff';
}, spin, function (props) {
	return getSize(props);
}, function (props) {
	return getSize(props);
});

var Spinner = function Spinner(props) {
	return _react2.default.createElement(
		StyledSpinner,
		props,
		_react2.default.createElement('span', null)
	);
};

exports.Spinner = Spinner;